<div mat-dialog-content class="form-container">
  <!-- <mat-horizontal-stepper [linear]="isLinear" #stepper>
        <mat-step [stepControl]="datosGestor"> -->
  <form [formGroup]="datosTransportista">
    <h1>Alta Transportista</h1>
    <div>
      <h2>Datos Transportista</h2>
      <mat-form-field appearance="outline">
        <mat-label>Denominación</mat-label>
        <input
          matInput
          placeholder="Denominación"
          formControlName="nombre"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>CIF</mat-label>
        <input matInput placeholder="CIF" formControlName="cif" required />
        <mat-error>Por favor introduzca un número de CIF válido</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Código Transportista</mat-label>
        <input
          matInput
          placeholder="Código Transportista"
          formControlName="codigo"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>NIMA</mat-label>
        <input matInput placeholder="Nima" formControlName="nima" required />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Mail de Contacto</mat-label>
        <input
          matInput
          placeholder="mail"
          formControlName="contacto"
          required
        />
      </mat-form-field>
    </div>
    <div>
      <button
        type="submit"
        (click)="addTransportista()"
        [mat-dialog-close]
        [disabled]="datosTransportista.invalid"
      >
        Hecho
      </button>
    </div>
  </form>
  <!--   </mat-step> -->
  <!--     <mat-step [stepControl]="secondFormGroup">
          <form [formGroup]="documentosGestor">
            <h1>Documentación Obligatoria</h1>
            <div>
                <h2>Autorización Gestor</h2>
            <mat-form-field>
              <mat-label>Subir documentación</mat-label>
              <input matInput formControlName="secondCtrl" placeholder="Ex. 1 Main St, New York, NY"
                     required>
            </mat-form-field>
            </div>
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step> -->
  <!-- </mat-horizontal-stepper> -->
</div>
